(function () {
  function init(root) {
    if (!root || root.dataset.aiInit) return;
    root.dataset.aiInit = '1';

    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    var delay = parseInt(root.dataset.closeDelay || '250', 10);
    var openOn = root.dataset.openOn || 'hover';
    var scroller = document.querySelector('.page-wrapper');

    function scrollTop() {
      var s = scroller && scroller.scrollHeight > scroller.clientHeight ? scroller.scrollTop : 0;
      return Math.max(s, window.scrollY || 0);
    }

    function update() {
      if (!root.hasAttribute('data-transparent')) return;
      var anyOpen = root.querySelector('.ai-hdr__nav details[open]');
      root.classList.toggle('is-filled', scrollTop() > 10 || root.matches(':hover') || !!anyOpen);
    }

    function closeOthers(keep) {
      root.querySelectorAll('.ai-hdr__nav details[open]').forEach(function (o) {
        if (o !== keep && !o.contains(keep)) o.open = false;
      });
    }

    window.addEventListener('scroll', update, { passive: true });
    if (scroller) scroller.addEventListener('scroll', update, { passive: true });
    root.addEventListener('mouseenter', update);
    root.addEventListener('mouseleave', function () { setTimeout(update, delay + 20); });
    update();

    root.querySelectorAll('.ai-hdr__nav [data-ai-dd]').forEach(function (d) {
      var timer;
      function open() {
        clearTimeout(timer);
        if (!d.classList.contains('ai-dd--nested')) closeOthers(d);
        d.open = true;
        update();
      }
      function scheduleClose() {
        clearTimeout(timer);
        timer = setTimeout(function () { d.open = false; update(); }, delay);
      }

      if (openOn === 'hover') {
        d.addEventListener('mouseenter', function () { if (fine.matches) open(); });
        d.addEventListener('mouseleave', function () { if (fine.matches) scheduleClose(); });
      }

      var summary = d.querySelector(':scope > summary');
      if (summary) {
        summary.addEventListener('click', function (e) {
          var link = e.target.closest('a');
          if (link && fine.matches && openOn === 'hover') return;
          if (link && !d.open) {
            e.preventDefault();
            open();
            return;
          }
          if (link) return;
          if (!d.open) { e.preventDefault(); open(); }
        });
      }
      d.addEventListener('toggle', update);
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closeOthers(null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeOthers(null);
    });

    var drawer = root.querySelector('[data-ai-drawer]');
    function setDrawer(isOpen) {
      if (!drawer) return;
      drawer.hidden = !isOpen;
      if (scroller) scroller.style.overflow = isOpen ? 'hidden' : '';
      document.documentElement.style.overflow = isOpen ? 'hidden' : '';
    }
    root.querySelectorAll('[data-ai-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(true); }); });
    root.querySelectorAll('[data-ai-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && !drawer.hidden) setDrawer(false); });
  }

  function boot() { document.querySelectorAll('[data-ai-header]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* Cart: open the theme cart drawer from the AI header, keep the header count in sync,
   and let AI quick-add buttons add to cart without leaving the page. */
(function () {
  if (window.__aiCartInit) return;
  window.__aiCartInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function drawer() {
    var d = document.getElementById('cart-drawer');
    return d && typeof d.open === 'function' ? d : null;
  }

  function setCount(n) {
    document.querySelectorAll('[data-ai-cart-link]').forEach(function (link) {
      var bubble = link.querySelector('.ai-hdr__count');
      if (!bubble) {
        bubble = document.createElement('span');
        bubble.className = 'ai-hdr__count';
        link.appendChild(bubble);
      }
      bubble.textContent = n;
      bubble.hidden = !n;
    });
  }

  function refreshCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); return c; })
      .catch(function () {});
  }

  function refreshDrawer() {
    var d = drawer();
    if (!d) return Promise.resolve();
    return fetch(root + '?sections=cart-drawer-section')
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var html = json && json['cart-drawer-section'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.cart-drawer__inner');
        var current = d.querySelector('.cart-drawer__inner');
        if (fresh && current) current.replaceWith(fresh);
      })
      .catch(function () {});
  }

  function markLinks() {
    document.querySelectorAll('.ai-hdr__icon[href$="/cart"]').forEach(function (a) { a.setAttribute('data-ai-cart-link', ''); });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-ai-cart-link]');
    if (!link) return;
    var d = drawer();
    if (!d) return;
    e.preventDefault();
    d.open();
  });

  document.addEventListener('shopify:cart:lines-update', function (e) {
    var done = function () { refreshCount(); };
    if (e && e.promise && e.promise.then) e.promise.then(done, done); else setTimeout(done, 800);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.ai-card__qb form');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    if (btn) btn.disabled = true;
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { return Promise.all([refreshCount(), refreshDrawer()]); })
      .then(function () { var d = drawer(); if (d) d.open(); else window.location.href = root + 'cart'; })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  function boot() { markLinks(); refreshCount(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(); });
})();
